<script>
import { EditIcon, TwitterIcon, SlackIcon, GithubIcon, ArrowRightIcon, MoonIcon, PlayIcon } from 'vue-feather-icons'
import DarkModeToggle from './DarkModeToggle.vue'
import Demo from './Demo.vue'

export default {
  components: {
    Demo,
    EditIcon,
    TwitterIcon,
    SlackIcon,
    GithubIcon,
    ArrowRightIcon,
    DarkModeToggle,
    MoonIcon,
    PlayIcon,
  },
}
</script>

<template>
  <div class="mx-auto px-8 pb-32">
    <div class="my-20">
      <img
        src="~@/assets/kibun-@1.svg"
        alt="Kibun logo"
        class="mx-auto mb-4 h-72p"
      >

      <div class="text-center text-sm text-red-500">
        Quickly share your status
      </div>
    </div>
    <div class="flex justify-center">
      <Demo v-if="!$responsive.lg" />

      <div class="max-w-440p mx-auto lg:mx-0 lg:ml-16 lg:mt-8">
        <div class="flex items-center border border-gray-300 dark:border-gray-700 rounded-lg px-4 min-h-72p py-2 mb-8">
          <img
            src="~@/assets/StarEyes.svg"
            alt="Star eyes emoji"
          >
          <div class="flex-1 text-gray-800 dark:text-gray-200 text-lg ml-4 leading-tight">
            <b>Share everywhere</b><br>in one click
          </div>

          <div
            v-if="!$responsive.xs"
            class="flex text-red-500 ml-4"
          >
            <TwitterIcon />
            <template v-if="!$responsive.sm">
              <SlackIcon class="ml-1" />
              <GithubIcon class="ml-1" />
            </template>
          </div>
        </div>

        <div class="flex items-center border border-gray-300 dark:border-gray-700 rounded-lg px-4 h-72p mb-8">
          <img
            src="~@/assets/Folders.svg"
            alt="Folders emoji"
            class="px-1"
          >
          <div class="flex-1 text-gray-800 dark:text-gray-200 text-lg ml-4 leading-tight">
            <b>Save your messages</b><br>for easy reuse
          </div>
          <EditIcon class="text-gray-500 dark:text-gray-600" />
        </div>

        <div class="flex items-center border border-gray-300 dark:border-gray-700 rounded-lg px-4 h-72p mb-8">
          <img
            src="~@/assets/Zap.svg"
            alt="Zap emoji"
            class="px-1"
          >
          <div class="flex-1 text-gray-800 dark:text-gray-200 text-lg ml-4 leading-tight">
            <b>Quick Status</b><br>for one-time updates
          </div>
          <EditIcon class="text-gray-500 dark:text-gray-600" />
        </div>

        <div class="flex items-center border border-gray-300 dark:border-gray-700 rounded-lg px-4 h-72p mb-8">
          <img
            src="~@/assets/Island.svg"
            alt="Island emoji"
            class="px-1"
          >
          <div class="flex-1 text-gray-800 dark:text-gray-200 text-lg ml-4">
            On Vacation
          </div>
          <EditIcon class="text-gray-500 dark:text-gray-600" />
        </div>

        <DarkModeToggle>
          <template #icon>
            <MoonIcon class="text-teal-500 w-8 h-8 ml-1 mr-5" />
          </template>
        </DarkModeToggle>

        <BaseButton
          v-if="$responsive.lg"
          :to="{ name: 'demo' }"
          class="flex items-center border border-gray-300 dark:border-gray-700 rounded-lg px-4 h-72p mb-8 w-full"
        >
          <img
            src="~@/assets/Phone.svg"
            alt="Phone emoji"
            class="px-1"
          >
          <div class="flex-1 text-gray-800 dark:text-gray-200 text-lg ml-4">
            Watch demo
          </div>
          <PlayIcon class="text-gray-500 dark:text-gray-600" />
        </BaseButton>

        <BaseButton
          :to="{ name: 'sign-in' }"
          class="flex items-center bg-yellow-200 dark:bg-transparent dark:border-red-700 dark:border rounded-lg
        px-4 h-72p mb-8 hover:bg-yellow-300 cursor-pointer dark-hover:bg-red-900 group"
        >
          <img
            src="~@/assets/Wink.svg"
            alt="Wink emoji"
            class="px-1"
          >
          <div class="flex-1 text-red-500 dark-group-hover:text-white text-lg ml-4">
            <div class="font-bold">
              Try it now!
            </div>
            <div class="opacity-50 text-sm">
              (No credit card required)
            </div>
          </div>
          <ArrowRightIcon class="text-red-500" />
        </BaseButton>

        <div class="flex justify-center">
          <BaseButton
            :to="{ name: 'sign-in' }"
          >
            Sign In
          </BaseButton>
        </div>

        <p class="text-gray-600 dark:text-gray-400 text-sm text-center mt-48">
          <BaseButton
            :to="{ name: 'tos' }"
            class="inline-flex underline"
          >
            Terms of Services
          </BaseButton>
          -
          <BaseButton
            :to="{ name: 'privacy'}"
            class="inline-flex underline"
          >
            Privacy policy
          </BaseButton>
        </p>
      </div>
    </div>
  </div>
</template>
